import { useTranslation } from "react-i18next";
import { Button } from "@/components/ui/button";
import Section from "@/components/Section";
import rocketImage from "@/assets/raket-1000px.jpg";

const AILyftet = () => {
  const { t } = useTranslation();

  return (
    <Section
      surface="alt"
      title={t("aiLyftet.title")}
    >
      <div className="grid md:grid-cols-2 gap-8 lg:gap-12 items-center">
        <div className="relative order-2 md:order-1">
          <div className="absolute -inset-2 bg-gradient-brand opacity-20 blur-2xl rounded-2xl" aria-hidden />
          <img
            src={rocketImage}
            alt={t("aiLyftet.imageAlt")}
            className="relative w-full h-auto rounded-2xl border border-border/60"
          />
        </div>

        <div className="space-y-6 order-1 md:order-2">
          <div className="space-y-4 text-muted-foreground text-lg leading-relaxed">
            <p>{t("aiLyftet.p1")}</p>
            <p>{t("aiLyftet.p2")}</p>
          </div>

          <a href="https://ai-lyftet.se/" target="_blank" rel="noopener noreferrer">
            <Button variant="secondary" size="lg" className="mt-2">
              {t("aiLyftet.readMore")}
            </Button>
          </a>
        </div>
      </div>
    </Section>
  );
};

export default AILyftet;
